// extracted by mini-css-extract-plugin
export default {"container":"KbaPopup_container__YxgZt","paper":"KbaPopup_paper__XZDx5","loaderContainer":"KbaPopup_loaderContainer__MVVf1"};